export default "__VITE_ASSET__yR8wzRy5__"